export const INBOUND_INSTRUCTIONS_FEATURE_FLAG_PREFIX = 'ENABLE_INBOUND_INSTRUCTIONS';
